const ActionsPanel = ({ actions, activeAction, onSelectAction }) => (
    <div className="d-flex flex-wrap gap-2 mb-3">
        {actions.map(({ id, label, icon: Icon, color }) => {
            const isActive = activeAction === id;

            return (
                <button
                    key={id}
                    type="button"
                    className="d-flex align-items-center gap-2 flex-grow-1"
                    style={{
                        border: isActive
                            ? `1px solid ${color}`
                            : '1px solid #e0e0e0',
                        borderRadius: 8,
                        padding: '8px 12px',
                        minWidth: 120,
                        backgroundColor: isActive ? '#fff' : '#fff',
                        color: color,
                        fontWeight: isActive ? 600 : 500,
                        fontSize: '0.8rem',
                        cursor: 'pointer',
                    }}
                    onClick={() => onSelectAction(id)}
                >
                    <Icon style={{ fontSize: 18 }} />
                    <span>{label}</span>
                </button>
            );
        })}
    </div>
);

export default ActionsPanel;
